module.exports = __webpack_public_path__ + "img/home_web_03.d3a2ea76.png";